import type { ICampaignFormData } from '@/Interfaces/CampaignManagement/CampaignForm.interface';

export const defaultFormData: ICampaignFormData = {
  name: '',
  advertiser: null,
  altId: '',
};
